import { Space } from '@sravni/react-design-system';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import type { GatewayRanking } from 'commonTypes/api/gatewayRanking';
import type { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

import { AdaptiveCard } from 'shared/ui/AdaptiveCard';
import { AdaptiveTitleText } from 'shared/ui/AdaptiveText';

import styles from './TopX.module.scss';
import { TOPX_TEXTS } from './TopX.texts';

type TopXProps = {
  allOffers: GatewayRanking.TRankingOffer[];
  firstName: string;
  isAllOffersWithStatus: boolean;
  applySelectedOffersButton: JSX.Element;
  topXBanksDropdown: JSX.Element;
  productType?: ValuesOf<typeof PRODUCT_TYPES_VALUES>;
};
export const TopXWlGrid: FC<TopXProps> = ({
  firstName,
  isAllOffersWithStatus,
  applySelectedOffersButton,
  topXBanksDropdown,
  productType,
}) => {
  const isMobile = useIsMobile();

  return (
    <AdaptiveCard className={styles.topXCardWl}>
      <Space
        direction="vertical"
        size={16}
      >
        <Space
          direction="vertical"
          size={8}
        >
          <Heading level={3}>
            {firstName}, {TOPX_TEXTS.TITLE}
          </Heading>
          <AdaptiveTitleText strong={false}>
            {productType ? TOPX_TEXTS.SUB_TITLE?.[productType] : TOPX_TEXTS.SUB_TITLE.Credit}
          </AdaptiveTitleText>
        </Space>
        <Space
          size={20}
          direction={isMobile ? 'vertical' : 'horizontal'}
        >
          {topXBanksDropdown}

          {isAllOffersWithStatus ? (
            <Space
              align="center"
              justify={isMobile ? 'center' : 'flex-start'}
            >
              <Text
                size={12}
                className={styles.allSentTextWl}
              >
                {TOPX_TEXTS.ALL_SENT_WL}
              </Text>
            </Space>
          ) : (
            applySelectedOffersButton
          )}
        </Space>
      </Space>
    </AdaptiveCard>
  );
};
